import React from 'react';

const OrderFilters = ({ Filter, setFilter, handleOrderFilter, handleReset, role }) => {
	// Reusable handler for setting filter values
	const handleFilterChange = (e) => {
		const { name, value } = e.target;
		setFilter((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	return (
		<div className='flex items-center space-x-4 mb-4'>
			<div className=' flex flex-wrap gap-3 lg:mb-8 mb-4'>
				<input
					type='date'
					name='DateFrom'
					placeholder='From Date'
					className='p-2 border rounded  text-sm max-[400px]:text-xs lg:w-auto w-1/4 max-[300px]:w-full'
					value={Filter.DateFrom}
					onChange={handleFilterChange}
				/>

				<input
					type='date'
					name='DateTo'
					placeholder='To Date'
					className='p-2 border rounded text-sm max-[400px]:text-xs lg:w-auto w-1/4 max-[300px]:w-full'
					value={Filter.DateTo}
					onChange={handleFilterChange}
				/>

				{role === 'ADMIN' && (
					<input
						type='text'
						name='CustomerName'
						placeholder='Customer Name'
						autoComplete='off'
						className='p-2 border rounded text-sm max-[400px]:text-xs lg:w-auto w-[40%] max-[300px]:w-full'
						value={Filter.CustomerName}
						onChange={handleFilterChange}
					/>
				)}

				<input
					type='text'
					name='OrderNumber'
					placeholder='Order Number'
					autoComplete='off'
					className='p-2 border rounded text-sm max-[400px]:text-xs lg:w-auto w-1/3 max-[300px]:w-full'
					value={Filter.OrderNumber}
					onChange={handleFilterChange}
				/>

				<select
					name='Status'
					className='p-2 border rounded  text-sm max-[400px]:text-xs lg:w-auto w-1/4 max-[300px]:w-full'
					value={Filter.Status}
					onChange={handleFilterChange}>
					<option value=''>Status</option>
					<option value='P'>PENDING</option>
					<option value='C'>COMPLETED</option>
					<option value='X'>CANCEL</option>
				</select>

				{role === 'ADMIN' && (
					<input
						type='text'
						name='MobileNo'
						placeholder='Mobile Number'
						autoComplete='off'
						className='p-2 border rounded text-sm max-[400px]:text-xs lg:w-auto w-1/3 max-[300px]:w-full'
						value={Filter.MobileNo}
						onChange={handleFilterChange}
					/>
				)}

				<div className=' flex flex-row gap-3 w-[52%] lg:w-auto max-[300px]:w-full'>
					<button
						type='button'
						onClick={handleOrderFilter}
						className='bg-red-500 text-white px-4 md:py-2 py-1 max-[300px]:py-2 text-sm rounded w-full lg:w-auto'>
						Search
					</button>

					<button
						type='button'
						onClick={handleReset}
						className='bg-red-500 text-white px-4 md:py-2 py-1 max-[300px]:py-2 text-sm rounded w-full lg:w-auto'>
						Reset
					</button>
				</div>
			</div>
		</div>
	);
};

export default OrderFilters;
